export const MAX_LENGTH = 2048

export type NoteDB = Record<string, UserLocalNote>

export const formatAPINotes = (notes: UserAPINote[]) => {
  const formatted: NoteDB = {}

  notes.forEach(note => {
    formatted[note.id] = { ...note, isOld: true } as UserLocalNote
  })

  return formatted
}
